import { render, staticRenderFns } from "./changeArchives.vue?vue&type=template&id=ace1747e&scoped=true&"
import script from "./changeArchives.vue?vue&type=script&lang=js&"
export * from "./changeArchives.vue?vue&type=script&lang=js&"
import style0 from "./changeArchives.vue?vue&type=style&index=0&id=ace1747e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace1747e",
  null
  
)

export default component.exports